export default "__VITE_ASSET__Bc6O19S2__"